// Copy for the landing page's immersive opening, drawn from the site's existing content in ./site.js.
import { company, services, highlights } from './site';

// "AI-Powered Salesforce Development" → "AI-Powered *Salesforce* Development"
const accentName = service => service.title.replace(service.name, `*${service.name}*`);

export const labCore = {
  label: company.slogan.join(' '),
  news: { text: 'Claudeforce & Agentforce expertise', to: '/salesforce#claudeforce' },
  title: 'Transforming business through *AI-driven* technology.',
  services: services.map(s => s.name).join(' · '),
  hint: 'Scroll to travel through our worlds'
};

export const labWorlds = services.map((service, i) => ({
  slug: service.slug,
  chapter: i + 1,
  index: service.index,
  name: service.name,
  label: service.label,
  title: accentName(service),
  description: service.description,
  features: service.features,
  path: service.path,
  highlight: highlights.find(h => h.service === service.slug),
  badge: service.slug === 'salesforce' ? 'New · Claudeforce & Agentforce' : null
}));

export const labWorldBySlug = Object.fromEntries(labWorlds.map(w => [w.slug, w]));

export const labOutro = {
  label: 'Choose a world',
  title: 'Where do you want to *go*?'
};
